import React, { useState } from "react";
import { FaReceipt } from "react-icons/fa";
import ReceiptGenerateModal from "../../components/modal/ReceiptCreateModal";
import {
  ReceiptCard,
  ReceiptCardBody,
  ReceiptCardIcon,
  ReceiptContainer,
  ReceiptHeader
} from "./receipt.styled";

const ReceiptPage: React.FC = () => {
  const [open, setOpen] = useState(false);

  return (
    <ReceiptContainer>
      <ReceiptHeader>
        <span className="eyebrow">Documentos</span>
        <h1>Recibos</h1>
        <p>Gere um recibo avulso para entregar ao cliente.</p>
      </ReceiptHeader>

      <ReceiptCard onClick={() => setOpen(true)} role="button" tabIndex={0}>
        <ReceiptCardIcon>
          <FaReceipt />
        </ReceiptCardIcon>
        <ReceiptCardBody>
          <h2>Gerar recibo</h2>
          <p>Escolha o cliente, o valor e emita o recibo em PDF na hora.</p>
        </ReceiptCardBody>
      </ReceiptCard>

      <ReceiptGenerateModal open={open} onClose={() => setOpen(false)} />
    </ReceiptContainer>
  );
};

export default ReceiptPage;
